__turbopack_context__.v({
  "benefit": "az5faq_benefit",
  "description": "az5faq_description",
  "disclaimer": "az5faq_disclaimer",
  "uhxInfoDescription": "az5faq_uhxInfoDescription",
});
